<template>
    <div class="brand-container noPrint">
        <div class="container">
            <div class="row">
                <div class="col-md-12">

                    <div class="coat-of-arms">
                        <img src="@/assets/images/bgnd-coat-of-arms-mini.gif" alt="Sodstvo Republike Slovenije"/>
                        {{$t('text.header.judiciaryOfSlovenia')}}
                    </div>

                    <div class="row appTitle">
                        <div class="col-md-3">
                            <router-link to="/" exact>
                                <img src="@/assets/images/vsrs.png" alt={logo} class="brand"/>
                            </router-link>
                        </div>

                        <div class="col-md-9">
                            <div class="info-board info-board-gray">
                                <div class="first-line">
                                    <span>
                                        {{$t('text.header.name')}}
                                    </span>

                                    <span class="badge-danger px-2" v-if="$globalFunctions.getAppVersionData('environment') !== 'PROD'"><b>{{version}}</b> <small> {{$t('text.header.environment')}}</small></span>


                                    <div class="user-info float-right" v-if="$keycloak.authenticated">
                                        <div class="text-right">{{$t('text.header.loggedInAs')}} <a
                                                id="userTooltip"
                                                v-b-tooltip.hover.html
                                                class="d-inline font-weight-bold pl-2"
                                                v-on:click="showUserDetailsModal()">

                                            <b-tooltip target="userTooltip" triggers="hover" class="text-left" v-if="displayPermissions.length > 2">
                                                <ol class="text-left">
                                                <li class="lm-fs-12 text-left" v-for="(item, index) in displayPermissions"
                                                      :key="'item_' + index"
                                                      style="font-size: 12px;">{{item.trim()}}<span
                                                        v-if="index < displayPermissions.length-1">,</span></li>
                                                </ol>
                                            </b-tooltip>

                                            <div class="user d-inline-block">
                                                <i class="fa fa-user mr-2" style="font-size: 1.3em"></i> {{getUserName}}
                                                <div class="badge badge-info rolesBadge" v-if="displayPermissions.length > 2">{{displayPermissions.length}}</div>
                                            </div>

                                            <span v-if="displayPermissions.length > 0 && displayPermissions.length <= 2">
                                                (<span class="lm-fs-12" v-for="(item, index) in displayPermissions"
                                                       :key="'item_' + index"
                                                       style="font-size: 12px;">{{item.trim()}}<span
                                                    v-if="index < displayPermissions.length-1">,</span></span>)
                                            </span>


                                        </a></div>
                                        <div class="text-right"><a class="d-inline font-weight-bold pl-2" style="cursor: pointer;" @click="logout">{{$t('text.header.logout')}}</a></div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="goldenStripe"></div>

        <b-navbar toggleable="lg" type="light" class="navbar-light bg-faded onWhiteBg" v-if="!$route.fullPath.includes('nedovoljen-dostop-do-vsebine')">
            <div class="container">

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <li class="nav-item">
                        <router-link :to="{ name: 'Dashboard'}" class="nav-link" active-class="active" exact><i
                                class="fa fa-home"></i> {{$t('text.header.navbar.home')}}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_KLASIF')">
                        <router-link :to="{ name: 'ClassificationPlan'}" class="nav-link" active-class="active"
                                     exact>
                            {{$t('text.header.navbar.classificationPlan')}}
                        </router-link>
                    </li>

                    <b-dropdown ref="dropdown1" id="dropdown-1" :text="$t('text.header.navbar.documents')" class="nav-item" v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META') || $globalFunctions.checkForPermission('POSR_DOK_IN_META')">
                        <b-dropdown ref="dropdown2" id="dropdown-2" :text="$t('text.header.navbar.searchAndOverviews')" class="nav-item" v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META')">
<!--                            <b-dropdown-item>First Action 2</b-dropdown-item>-->
<!--                            <b-dropdown-item>Second Action 2</b-dropdown-item>-->
                            <li class="nav-item"
                                v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META')">
                                <router-link :to="{ name: 'DocumentSearchFullText' }"
                                             class="nav-link" active-class="active"
                                             exact>{{$t('text.header.navbar.documentSearchFullText')}}
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META')">
                                <router-link :to="{ name: 'DocumentSearchDetailed' }"
                                             class="nav-link" active-class="active"
                                             exact>{{$t('text.header.navbar.documentSearchDetailed')}}
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META')">
                                <router-link :to="{ name: 'DocumentSearchQuery' }"
                                             class="nav-link" active-class="active"
                                             exact>{{$t('text.header.navbar.documentSearchQuery')}}
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$globalFunctions.checkForPermission('ISCI_DOK_IN_META')">
                                <router-link :to="{ name: 'UnclassifiedFilesReview' }"
                                             class="nav-link" active-class="active"

                                             exact>{{$t('text.header.navbar.unclassifiedFilesReview')}}
                                </router-link>
                            </li>
                        </b-dropdown>

                      <li class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_IZLOCANJE_UNICENJE')">
                        <router-link :to="{ name: 'DocumentListPretecenRokHrambe', params: {} }"
                                     class="nav-link" active-class="active"
                                     exact>{{$t('text.header.navbar.documentListPretecenRokHrambe')}}
                        </router-link>
                      </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_IZLOCANJE_UNICENJE')">
                            <router-link :to="{ name: 'DocumentListReview', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.expiredDocuments')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SEZNAM_DODELJENI_ZA_PREGLED')">
                            <router-link :to="{ name: 'DocumentListReviewSkrbnik', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.documentsAssignedIntoReview')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SEZNAM_ODBIRANJE_IZROCANJE')">
                            <router-link :to="{ name: 'DocumentList4', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.documentsProposedForDestruction')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SEZNAM_POTRJENI_ZA_UNICENJE')">
                            <router-link :to="{ name: 'DocumentList2', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.documentsReviewedAndConfirmedForDestruction')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SEZNAM_ODBIRANJE_IZROCANJE')">
                            <router-link :to="{ name: 'DocumentList3', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.documentsForSubmissionToArchive')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SEZNAM_ODBIRANJE_IZROCANJE')">
                            <router-link :to="{ name: 'DocumentList5', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.documentsReviewedByArchive')}}
                            </router-link>
                        </li>

                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('LAHKO_PRETVARJA_DOKUMENTE')">
                            <router-link :to="{ name: 'DocumentListLongTermStorage', params: {} }"
                                         class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.conversionForLongTermStorage')}}
                            </router-link>
                        </li>

                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('IZDELAJ_PAKET_ZA_PRENOS')">
                            <router-link :to="{ name: 'KandidatiZaIzrocanje', params: {} }"
                                         class="nav-link" active-class="active"

                                         exact>{{$t('text.header.navbar.candidatesForDelivery')}}
                            </router-link>
                        </li>

                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('POROCILO_IZVOZ')">
                            <router-link :to="{ name: 'IzrocenoGradivo', params: {} }"
                                         class="nav-link" active-class="active"

                                         exact>{{$t('text.header.navbar.deliveredDocuments')}}
                            </router-link>
                        </li>

                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('IZDELAJ_PAKET_ZA_PRENOS')">
                            <router-link :to="{ name: 'RocniVnosStatusaPrevzemaPaketa', params: {} }"
                                         class="nav-link" active-class="active"

                                         exact>{{$t('text.header.navbar.deliveryStatusManualEntry')}}
                            </router-link>
                        </li>


                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('POSR_DOK_IN_META') && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                            <router-link :to="{ name: 'DocumentTestClient', params: {} }"
                                         class="nav-link" active-class="active"

                                         exact>{{$t('text.header.navbar.documentUploadTestClient')}}
                            </router-link>
                        </li>

                    </b-dropdown>

                    <li class="nav-item" v-if="$globalFunctions.checkForPermission('POROCILO_ENOTE_GRADIVA')">
                        <router-link :to="{ name: 'Reports', params: {} }" class="nav-link" active-class="active" exact>{{$t('text.header.navbar.reports')}}
                        </router-link>
                    </li>


                    <b-dropdown ref="dropdown3" id="dropdown-3" :text="$t('text.header.navbar.system')" class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_SISTEMA') || $globalFunctions.checkForPermission('PREGLED_REVIZ_SLED') || $globalFunctions.checkForPermission('ISCI_REVIZ_SLED') || $globalFunctions.checkForPermission('IZVOZ_REVIZ_SLED') || $globalFunctions.checkForPermission('SISTEM_SPREMLJA_DELOVANJE')">
                        <b-dropdown ref="dropdown4" id="dropdown-4" :text="$t('text.header.navbar.auditLog')" class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_REVIZ_SLED')">
                            <li class="nav-item" v-if="$globalFunctions.checkForPermission('PREGLED_REVIZ_SLED')">
                                <router-link :to="{ name: 'AuditLog', params: {} }"
                                             class="nav-link" active-class="active"

                                             exact>{{$t('text.header.navbar.auditLogSearch')}}
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$globalFunctions.checkForPermission('UVOZ_REVIZ_SLED')">
                                <router-link :to="{ name: 'AuditLogExternalImport', params: {} }"
                                             class="nav-link" active-class="active"

                                             exact>{{$t('text.header.navbar.externalAuditLogImport')}}
                                </router-link>
                            </li>
                        </b-dropdown>
                        <li class="nav-item" v-if="$globalFunctions.checkForPermission('SISTEM_SPREMLJA_DELOVANJE')">
                            <router-link :to="{name: 'Apm'}" class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.systemPerformance')}}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="($globalFunctions.checkForPermission('PREGLED_SISTEMA') || $globalFunctions.checkForPermission('DODAJ_PREDPOMNILNIK'))">
                            <router-link :to="{name: 'Status'}" class="nav-link" active-class="active"
                                         exact>{{$t('text.header.navbar.systemStatus')}}
                            </router-link>
                        </li>
                        <b-dropdown ref="dropdown5" id="dropdown-5" :text="$t('text.globals.adminTools')" class="nav-item" v-if="$globalFunctions.checkForPermission('OSTALA_SIST_OPRAVILA')">
                            <li class="nav-item" v-if="$globalFunctions.getAppVersionData('environment') !== 'PROD'">
                                <router-link to="/models" class="nav-link"
                                             active-class="active" exact>{{$t('text.header.navbar.modelsAndMetadataSettings')}}
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$globalFunctions.checkForPermission('OSTALA_SIST_OPRAVILA')">
                                <router-link to="/registerAdministration" class="nav-link"
                                             active-class="active" exact>Administracija šifrantov

                                </router-link>
                            </li>
                          <li class="nav-item" v-if="$globalFunctions.checkForPermission('OSTALA_SIST_OPRAVILA') && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                            <router-link to="/mq-test-client" class="nav-link"
                                         active-class="active" exact>MQ testni klient

                            </router-link>
                          </li>
                            <li class="nav-item" v-if="$globalFunctions.checkForPermission('OSTALA_SIST_OPRAVILA')">
                                <router-link to="/alfresco-share" class="nav-link"
                                             active-class="active" exact>Datotečni sistem

                                </router-link>
                            </li>
                          <li class="nav-item" v-if="$globalFunctions.checkForPermission('OSTALA_SIST_OPRAVILA')">
                            <router-link to="/package-export" class="nav-link"
                                         active-class="active" exact>{{$t('text.packageExport.title')}}

                            </router-link>
                          </li>
<!--                            <li class="nav-item"><a class="nav-link">{{$t('text.header.navbar.miscellaneousSettings')}}</a></li>-->
                        </b-dropdown>
                    </b-dropdown>




                </b-navbar-nav>


            </b-collapse>
            </div>
        </b-navbar>


        <b-modal ref="metadata-modal" title="Podatki o uporabniku" size="lg">


            <div class="mb-5">
                <div class="row mb-5">
                    <div class="col-md-12 mb-0">

                        <div class="text-center mt-5" v-if="getPermissions.length === 0">
                            <em>
                                <i class="fa fa-exclamation-triangle"></i> {{$t('text.header.noInfoOrNoPermissions')}}
                            </em>
                        </div>
                        <div v-for="(item, index) in uniqueRoles.permissions" class="mt-1 mb-2">
                            <h6>Vloga <b>{{item.description}}</b>
                                <div v-for="(court, index) in item.court">
                                <small v-if="court.court">{{$t('text.globals.court')}}: {{court.court === 'ALL' ? 'vsa sodišča' : $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:sodisce', court.court)}} (Vpisnik: {{court.register === 'ALL' ? 'vsi vpisniki' : $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:oznaka_vpisnika', court.register)}})</small>
                                <small v-if="!court.court">{{$t('text.globals.court')}}: {{$t('text.header.allCourts')}}</small>
                                <small v-if="court.connectedSystem">{{$t('text.classificationPlanMetadata.connectedSystem')}}: {{court.connectedSystem === 'ALL' ? 'vsi povezani sistemi' : $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:oznaka_povezanega_sistema', court.connectedSystem)}}</small>
                                </div>
                            </h6>
                            Pravice
                            <ul class="list-group" v-if="uniqueRoles.permissions[index]">
                                <li class="list-group-item" v-for="(i, index2) in uniqueRoles.permissions[index].permissions"
                                    style="font-size: 12px;"><i class="fa fa-check-circle text-success"></i><span> {{i.description}} <span
                                        class="text-muted">({{i.id}})</span></span></li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        id="headerCloseModalButton1"
                        variant="primary"
                        class="float-right"
                        @click="closeModal">
                    {{$t('text.globals.ok')}}
                </b-button>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import Vue from 'vue';
    import Cookies from 'universal-cookie';
    import axios from 'axios/index';
    import Dropdown from 'bp-vuejs-dropdown';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'
    import QueryString from "query-string";
    import {version} from '../../package';

    library.add(faInfoCircle);

    const cookies = new Cookies();

    export default {
        name: 'Header',
        components: {
            Dropdown
        },

        data() {
            return {
                version: null,
                allMetadataOptions: null,
                uniqueRoles: [],
                isDropdown1Visible: false,
                isDropdown2Visible: false,
                isDropdown4Visible: false,
                isDropdown3Visible: false,
                isDropdown5Visible: false,
            };
        },
        watch: {
            '$route' (to, from) {
                console.log("$route");
                const _this = this;
                setTimeout(() => {
                    if(_this.$refs.dropdown5) {
                        _this.$refs.dropdown5.hide();
                    }

                    if(_this.$refs.dropdown4) {
                        _this.$refs.dropdown4.hide();
                    }

                    if(_this.$refs.dropdown3) {
                        _this.$refs.dropdown3.hide();
                    }

                    if(_this.$refs.dropdown2) {
                        _this.$refs.dropdown2.hide();
                    }

                    if(_this.$refs.dropdown1) {
                        _this.$refs.dropdown1.hide();
                    }

                    _this.isDropdown1Visible= false;
                    _this.isDropdown2Visible= false;
                    _this.isDropdown4Visible= false;
                    _this.isDropdown3Visible= false;
                    _this.isDropdown5Visible= false;
                }, 50);
            }
        },
        mounted() {
            const _this = this;


            this.version = this.$globalFunctions.getAppVersionData("environment");

            let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
            });


            _this.$root.$on('bv::dropdown::show', bvEvent => {
                console.log("show: ", bvEvent.componentId);

                let dropdownIdNum = bvEvent.componentId.match(/(\d+)/)[0];
                _this['isDropdown' + dropdownIdNum + 'Visible'] = true;

            })
            this.$root.$on('bv::dropdown::hide', bvEvent => {
                console.log("hide: ", bvEvent.componentId);

                if(bvEvent.componentId === 'dropdown-2') {
                    this.isDropdown2Visible = false;
                }
                if(this.isDropdown2Visible) {
                    bvEvent.preventDefault()
                }

                if(bvEvent.componentId === 'dropdown-4') {
                    this.isDropdown4Visible = false;
                }
                if(this.isDropdown4Visible) {
                    bvEvent.preventDefault()
                }

                if(bvEvent.componentId === 'dropdown-5') {
                    this.isDropdown5Visible = false;
                }
                if(this.isDropdown5Visible) {
                    bvEvent.preventDefault()
                }

            });
        },
        computed: {
            getUserName() {
                console.log("this.$store.getters.getUserName", this.$store.getters.getUserName);
                return this.$store.getters.getUserName;
            },
            getPermissions() {
                this.allPermissions(this.$store.getters.getPermissions);
                return this.$store.getters.getPermissions;
            },
            displayPermissions() {
                let permissions = [];
                if(this.getPermissions.length === 0) {
                    return [];
                }
                _.map(this.getPermissions, function (val) {
                    if (permissions.indexOf(val.description) === -1) {
                        permissions.push(val.description);
                    }
                });

                return permissions;
            }
        },

        methods: {

            allPermissions(permissions) {
                console.log("PERMISSIONI --> ", permissions);
                let uniqueRoles = {uniqueRoles: [], permissions: []};
                for(let i = 0; i < permissions.length; i ++) {
                    if(!uniqueRoles.uniqueRoles.includes(permissions[i].role)) {
                        uniqueRoles.uniqueRoles.push(permissions[i].role);
                        let permissionObject = {role: permissions[i].role, court: [], description: permissions[i].description, permissions: permissions[i].permissions};
                        let courtAndRegObject = {court: permissions[i].court, register: permissions[i].register};
                        permissionObject.court.push(courtAndRegObject);
                        uniqueRoles.permissions.push(permissionObject);

                    }
                    else {
                        let index = uniqueRoles.uniqueRoles.indexOf(permissions[i].role);
                        let courtAndRegObject = {court: permissions[i].court, register: permissions[i].register};
                        uniqueRoles.permissions[index].court.push(courtAndRegObject);

                    }
                }

                console.log("UNIQUE VLOGE ---> ", uniqueRoles);
                this.uniqueRoles = uniqueRoles;


            },

            // getVersion() {
            //     if(version.indexOf('-') > -1) {
            //         let version = version.split('-')[1];
            //         if(version != 'PROD') {
            //             return version
            //         } else {
            //             return
            //         }
            //     } else {
            //         return
            //     }
            // },

            showUserDetailsModal: function () {
                this.$refs['metadata-modal'].show();
            },

            closeModal: function () {
                const _this = this;

                if (this.$refs['metadata-modal']) {
                    this.$refs['metadata-modal'].hide();
                }

            },

            beforeMenuOpen: resolve => {
                setTimeout(() => {
                    console.log('I\'m called!');
                    resolve(); // don't forget call resolve!
                }, 1);
            },

            // beforeMenuOpen: function() {
            //     const _this = this;
            //     //return resolve();
            //     // return new Promise((resolve) => {
            //     //    return resolve();
            //     // }).then(() => {
            //     //     console.log("tole");
            //     // });
            //
            //
            //
            //
            //     // resolve();
            //
            //
            //
            //     // setTimeout(() => {
            //     //     console.log('I\'m called!');
            //     //     resolve(); // don't forget call resolve!
            //     // }, 1000);
            // },

            logout() {
                console.log("Route name: ",this.$router.app._route.name);

                if(this.$router.app._route.name != 'Dashboard') {
                    this.$router.replace({name: 'Dashboard', query: { logout: 'true' }}).catch(()=>{});
                } else {
                    this.$router.push(this.$route.path).catch(()=>{});
                    this.$keycloak.logoutFn();
                }
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Header.vue